import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { NavBarArea } from './nav-bar-area';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [RouterLink, RouterLinkActive],
})
export class SidebarComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  private activeNavBarArea: NavBarArea = NavBarArea.Settings;
  ngOnInit(): void {
    this.route.url.subscribe((url) => {
      if (url.find((segment) => segment.path.includes('phishing'))) {
        this.activeNavBarArea = NavBarArea.Phishing;
      }
    });
  }

  isNavBarSettingsActive(): boolean {
    return this.activeNavBarArea === NavBarArea.Settings;
  }
  protected isNavBarPhishingActive(): boolean {
    return this.activeNavBarArea === NavBarArea.Phishing;
  }
}
